<template>
  <div class="mainArea CInitManage">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <CBreadCrumb></CBreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <!-- 搜索框 -->
      <div class="searchBox">
        <el-input class="searchInput" placeholder="产品编号或产品名称" v-model="keyword.ProductName" clearable @keyup.enter.native="ProductBomList(1)"></el-input>
        <el-select v-model="keyword.type" placeholder="请选择类别" clearable @change="ProductBomList(1)">
          <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in typeList" :key="index"></el-option>
        </el-select>
        <el-input class="searchInput" placeholder="请输入RFID编号" v-model="keyword.RFID" clearable @keyup.enter.native="ProductBomList(1)"></el-input>
        <el-cascader popper-class="casNoRadio" @change="cargoChange($event,'1')" placeholder="请选择货位信息" :options="keyword.cargoList" filterable :props="keyword.props" :show-all-levels="false" clearable></el-cascader>
        <el-button class="searchBtn" type="primary" @click="ProductBomList(1)">搜 索</el-button>
      </div>
      <!-- 添加信息 -->
      <div class="addButton">
        <el-button type="primary" @click="openDio('add')">添加</el-button>
        <!-- <el-button type="warning">批量导入</el-button> -->
      </div>

      <el-table v-loading="loading" :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column label="产品编号" prop="ProductSn"></el-table-column>
        <el-table-column label="产品名称" prop="ProductName"></el-table-column>
        <el-table-column label="类别" prop="Type"></el-table-column>
        <el-table-column label="RFID编号" prop="Rfid"></el-table-column>
        <el-table-column label="限制货架" prop="RackName"></el-table-column>
        <el-table-column label="限制货位" prop="ZhyName"></el-table-column>
        <el-table-column label="添加时间" prop="CreatedTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openDio('edit',scope.row)">修改</el-button>
            <el-button type="text" @click="openDio('del',scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging" v-if="total>limits">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="limits"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="InwareDio" :width="dioWidth" class="configDio wareDio" center @close="closeDio">
        <div class="contDio" v-if="dioType == 'add'">
          <el-form :inline="true" :model="dioform" label-position="top">
            <el-form-item label="产品编号">
              <el-autocomplete
                v-model="dioform.ProductId"
                :fetch-suggestions="querySearch"
                placeholder="输入产品名称搜索或双击选择产品"
                :trigger-on-focus="false"
                value-key="Sn"
                @select="handleSelect"
                @dblclick.native="openProductDio"
              ></el-autocomplete>
              <!-- <el-input type="text" v-model="dioform.ProductId" @dblclick.native="openProductDio" placeholder="输入产品名称搜索或双击选择产品"></el-input> -->
            </el-form-item>
            <el-form-item label="产品名称">
              <el-input type="text" disabled v-model="dioform.ProductName"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <el-checkbox v-model="dioform.IsAddress" @change="AddressChange($event)">限制位置</el-checkbox>
              </span>
              <el-cascader
                :disabled="dioform.IsAddress == false"
                @change="cargoChange($event,'2')" 
                placeholder="请选择限制位置" 
                :options="dioform.cargoList" 
                filterable 
                :props="keyword.props" 
                :show-all-levels="false" 
                popper-class="casNoRadio"
                clearable></el-cascader>
            </el-form-item>
            <el-form-item label="RFID编号">
              <el-input v-model="dioform.Rfid" type="text" class="w300" placeholder="请输入RFID"></el-input>
              <el-button type="primary" @click="addRfid('1')">添加</el-button>
              <el-button type="primary" @click="addRfid('2')">连续添加</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="dioform.tabData" style="width: 100%" max-height="300">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="产品编号" prop="ProductSn"></el-table-column>
            <el-table-column label="产品名称" prop="Name"></el-table-column>
            <el-table-column label="RFID编号" prop="Rfid"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="delRfid(scope.$index)">[-]</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="contDio" v-else-if="dioType == 'edit'">
          <div class="flex">
            <div>产品编号：{{dioform.ProductId}}</div>
            <div>产品名称：{{dioform.ProductName}}</div>
          </div>
          <el-form :model="dioform" label-position="top">
            <el-form-item>
              <span slot="label">
                <el-checkbox v-model="dioform.IsAddress" @change="AddressChange($event)">限制位置</el-checkbox>
              </span>
              <el-cascader
              :disabled="dioform.IsAddress == false"
              v-model="dioform.Address"
              @change="cargoChange($event,'2')" 
              placeholder="请选择限制位置" 
              :options="dioform.cargoList" 
              filterable 
              popper-class="casNoRadio"
              :props="keyword.props" 
              :show-all-levels="false" 
              clearable></el-cascader>
            </el-form-item>
            <el-form-item label="RFID编号">
              <el-input v-model="dioform.Rfid" type="text" placeholder="请输入RFID"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="closeDio">取消</el-button>
          <el-button v-if="dioType == 'add'" type="primary" @click="BatchAddProductBom">确定</el-button>
          <el-button v-if="dioType == 'edit'" type="primary" @click="SaveProductBom">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="选择产品" :visible.sync="productDio" width="800px" class="configDio">
        <div class="contDio">
          <div class="search">
            <el-input size="small" v-model="productform.name" placeholder="产品编号或产品名称" clearable class="w235" @keyup.enter.native="ProductList('2',1)"></el-input>
            <el-select size="small" v-model="productform.Type" placeholder="请选择类别" clearable @change="ProductList('2',1)">
              <el-option v-for="(item,index) in typeList" :key="index" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <el-button size="small" type="primary" @click="ProductList('2',1)">搜索</el-button>
          </div>
          <el-table :data="productform.list" style="width:100%" @current-change="clickChange" max-height="400px" class="productTable">
            <el-table-column label="选择" width="55" fixed>
              <template slot-scope="scope">
                <el-radio v-model="productform.checkrow" :label="scope.row"></el-radio>
              </template>
            </el-table-column>
            <el-table-column label="产品编号" prop="Id"></el-table-column>
            <el-table-column label="产品名称" prop="ProductName"></el-table-column>
            <el-table-column label="产品批号" prop="ProductNumber"></el-table-column>
            <el-table-column label="类别" prop="Type"></el-table-column>
            <el-table-column label="规格" prop="Spec"></el-table-column>
            <el-table-column label="单位" prop="Unit"></el-table-column>
            <el-table-column label="重量" prop="Weight"></el-table-column>
            <el-table-column label="供应商" prop="Supplier"></el-table-column>
            <el-table-column label="生产日期" prop="Date"></el-table-column>
            <el-table-column label="有效期" prop="Validity"></el-table-column>
          </el-table>
          <div class="Ppaging" v-if="Ptotal>Plimits">
            <el-pagination
              small
              @current-change="PCurrentChange"
              :current-page.sync="Pcurr"
              :page-size="Plimits"
              layout="prev, pager, next, jumper"
              :total="Ptotal">
            </el-pagination>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="chooseProduct">确定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>
<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { bussinessApi } from '../../../../../static/js/api';
  var vm
  export default {
    name:'CInitManage',
    data(){
      return {
        //搜索
        keyword:{
          ProductName:'',//产品名称
          RFID:'',//RFID编号
          type:'',//类别
          cargo:'',//货位
          cargoList:[],
          props:{
            checkStrictly: true,
            label:'Name',
            value:'TreeId',
            children:'Children'
          },
        },
        typeList:[],//类别数据
        LocalTree:[],//仓库到货位数据

        loading:false,//表格刷新
        tableData:[],//表格数据

        //分页
        curr:1,
        limits:10,
        total:0,

        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        InwareDio:false,//弹窗状态
        dioform:{
          ProductId:'',
          pId:'',
          ProductName:'',
          IsAddress:false,//是否限制位置
          cargoList:[],
          Rfid:'',
          tabData:[],
          Address:[],
          productList:[],
        },
        //分页
        Pcurr:1,
        Plimits:10,
        Ptotal:0,

        productDio:false,
        productform:{
          name:'',
          Type:'',
          list:[],
          checkrow:'',
        }

      }
    },
    components: {
      CBreadCrumb,
    },
    created(){
      vm = this
      vm.ProductBomList()
      vm.WarehouseTree();//获取位置数据
      vm.ProductTypeList();//类别
    },
    methods:{
      //修改初始化产品
      async SaveProductBom(){
        var data = {}
        if(vm.dioType !='del'){
          var strArr = vm.dioform.Address !='' ? vm.dioform.Address[vm.dioform.Address.length-1].split('_') : []
          data.Id = vm.dioform.pId
          data.ProductSn = vm.dioform.ProductId
          data.Name = vm.dioform.ProductName
          data.Rfid = vm.dioform.Rfid
          data.StorageRackId = vm.dioform.IsAddress == true && strArr[0] == 2 ? strArr[1] : 0
          data.ZhyId = vm.dioform.IsAddress == true && strArr[0] == 3 ? strArr[1] : 0
          data.Edit = '2'
        }else if(vm.dioType == 'del'){
          data.Id = vm.dioform.pId
          data.ProductSn = vm.dioform.ProductId
          data.Edit = '3'
        }
        const res = await bussinessApi.SaveProductBom(data)
        if(res.ErrCode == 0){
          showToast('操作成功')
          vm.closeDio()
          vm.ProductBomList(1)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //批量添加初始化产品
      async BatchAddProductBom(){
        if(vm.dioform.tabData == ''){
          showToast('未添加产品数据')
          return
        }
        let dataObj = {
          'Data': vm.dioform.tabData
        }
        const res = await bussinessApi.BatchAddProductBom(dataObj)
        if(res.ErrCode == 0){
          showToast('添加成功!')
          vm.closeDio()
          vm.ProductBomList(1)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //确定选择产品
      chooseProduct(){
        vm.dioform.ProductId = vm.productform.checkrow.Sn
        vm.dioform.ProductName = vm.productform.checkrow.ProductName
        vm.productform.name=''
        vm.productform.Type=''
        vm.productform.checkrow=''
        vm.productDio = false
      },
      //删除RFID
      delRfid(index){
        vm.dioform.tabData.splice(index,1)
      },
      //添加RFID
      addRfid(type){
        if(vm.dioform.ProductId == ''){
          showToast('请输入产品编号')
          return
        }
        if(vm.dioform.Rfid == ''){
          showToast('请输入RFID')
          return
        }
        let strArr =vm.dioform.Address !='' ? vm.dioform.Address[vm.dioform.Address.length-1].split('_') : []
        let obj = {
          'ProductSn': vm.dioform.ProductId,
          'Name': vm.dioform.ProductName,
          'Rfid': vm.dioform.Rfid,
          'StorageRackId': vm.dioform.IsAddress == true && strArr[0] == 2 ? strArr[1] : 0,
          'ZhyId': vm.dioform.IsAddress == true && strArr[0] == 3 ? strArr[1] : 0,
        }
        var arr = vm.dioform.tabData
        var result = arr.some(item=>{
          if(item.ProductSn==obj.ProductSn && item.Rfid==obj.Rfid){
            return true 
          } 
        })
        var arr2 = vm.dioform.productList
        var result2 = false
        arr2.forEach(item=>{
          if(obj.ProductSn==item.Sn){ // 对象里的唯一标识id
            result2 = true
          }
        })
        if(result == true){
          showToast('请勿重复添加')
        }else if(result2 == false){
          showToast('不存在的产品编号')
        }else{
          vm.dioform.tabData.push(obj)
        }
        //判断是点了添加按钮（type=1）还是连续添加按钮
        if(type == '1'){
          vm.dioform.ProductId = ''
          vm.dioform.ProductName = ''
          vm.dioform.Address = []
          vm.dioform.IsAddress = false
          vm.dioform.cargoList = []
          vm.dioform.Rfid = ''
        }else{
          vm.dioform.Rfid = ''
        }
      },
      //通过产品编号搜索符合的产品
      querySearch(queryString, cb) {
        var restaurants = vm.dioform.productList;
        var results = queryString ? restaurants.filter(vm.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.Sn.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        vm.dioform.ProductName = item.ProductName
      },

      //打开选择产品弹窗
      openProductDio(){
        vm.ProductList('2')
        vm.productDio = true
      },
      //获取产品列表
      async ProductList(type,curr,limits){
        var data = {
          'Product':vm.productform.name,
          'TypeId':vm.productform.Type,
          'Curr':type == '1'? 1 : curr ? curr : vm.Pcurr,
          'Limits':type == '1'? 99999 : limits ? limits : vm.Plimits,
        }
        const res = await bussinessApi.ProductList(data)
        if(res.ErrCode == 0){
          if(type == 1){
            vm.dioform.productList = res.Result.List
          }else{
            vm.productform.list = res.Result.List
            vm.Pcurr = parseInt(res.Result.Curr)
            vm.Ptotal = parseInt(res.Result.Total)
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //分页
      PCurrentChange(val){
        vm.Pcurr = val
        //执行列表方法
        vm.ProductList('2',val)
      },
      //单选产品
      clickChange(val){
        this.productform.checkrow = val
      },

      //递归方法(给树形数据添加多一个唯一值:TreeId)
      foreachFun(data){
        for(var i in data){
          data[i].TreeId = data[i].Level + '_' + data[i].Id
          if(data[i].Children){
            if(data[i].Children.length == 0){
              delete data[i].Children
            }
            vm.foreachFun(data[i].Children)
          }
        }
        return data
      },
      // 获取位置列表
      async WarehouseTree() {
        let res = await bussinessApi.WarehouseTree()
        if(res.ErrCode == 0){
          const data = vm.foreachFun(res.Result.Data)
          vm.LocalTree = data
          vm.keyword.cargoList = data
        }
      },
      //改变限制位置
      AddressChange(value){
        vm.dioform.Address = []
        if(value == false){
          vm.dioform.cargoList=[]
        }else{
          vm.dioform.cargoList = vm.LocalTree
        }
      },
      //货位选择
      cargoChange(value,type){
        if(type == '1'){
          vm.keyword.cargo = value[value.length-1]
          vm.ProductBomList(1)
        }else{
          vm.dioform.Address = value
        }
        
      },
      //打开弹窗
      openDio(type,info){
        vm.dioType = type
        if(type != 'del'){
          vm.dioform.cargoList = vm.LocalTree
          if(type == 'add'){
            vm.ProductList('1')
            vm.dioWidth="700px"
            vm.dioTitle="添加"
          }else if(type == 'edit'){
            vm.dioWidth="500px"
            vm.dioTitle="修改"
            vm.dioform.pId = info.Id
            vm.dioform.ProductId = info.ProductSn
            vm.dioform.ProductName = info.ProductName
            vm.dioform.Rfid = info.Rfid
            vm.dioform.IsAddress = info.RackId == 0 && info.ZhyId == 0 ? false : true
            var arr = []
            arr = info.ZhyId == 0 ? ['0_'+info.WareId,'1_'+info.LocationId] : ['0_'+info.WareId,'1_'+info.LocationId,'2_'+info.RackId]

            var str = '2_'+info.RackId
            var str2 = '3_'+info.ZhyId
            if(info.RackId != 0 && info.ZhyId == 0){
              arr.push(str)
            }else if(info.ZhyId != 0){
              arr.push(str2)
            }
            vm.dioform.Address = info.RackId != 0 && info.ZhyId == 0 ? arr : info.ZhyId != 0 ? arr : []
          }
          vm.InwareDio = true
        }else{
          vm.dioform.pId = info.Id
          vm.dioform.ProductId = info.ProductSn
          vm.$confirm('确定删除该产品？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            vm.SaveProductBom()
          }).catch(() => {});
        }
      },
      //关闭弹窗
      closeDio(){
        vm.dioform={
          ProductId:'',
          pId:'',
          ProductName:'',
          IsAddress:false,//是否限制位置
          cargoList:[],
          Rfid:'',
          tabData:[],
          Address:[],
          productList:[],
        }
        vm.InwareDio = false
      },

      //获取初始化产品列表
      async ProductBomList(curr,limits){
        let data = {
          'Product': vm.keyword.ProductName,
          'Type': vm.keyword.type,
          'Rfid': vm.keyword.RFID,
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.limits,
        }
        if(vm.keyword.cargo !=''){
          var strArr = vm.keyword.cargo.split('_');//字符串转数组
          data.WarehouseId = strArr[0] == 0 ? strArr[1] : '';
          data.StorageLocationId = strArr[0] == 1 ? strArr[1] : '';
          data.StorageRackId = strArr[0] == 2 ? strArr[1] : '';
          data.ZhyId = strArr[0] == 3 ? strArr[1] : '';
        }
        vm.loading = true
        const res = await bussinessApi.ProductBomList(data)
        vm.loading = false
        if(res.ErrCode == 0 ){
          if(res.Result){
          vm.tableData = res.Result.List
          vm.curr = parseInt(res.Result.Curr)
          vm.total = parseInt(res.Result.Total)
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //分页
      CurrentChange(val){
        vm.curr = val
        //执行列表方法
        vm.ProductBomList(val)
      },
      //获取产品类型
      async ProductTypeList(){
        let data = {
          'KeyWord':'',
          'Curr':1,
          'Limits':99999
        }
        const res = await bussinessApi.ProductTypeList(data)
        if(res.ErrCode == 0){
          vm.typeList = res.Result.List
        }else{
          showToast(res.ErrMsg)
        }
      },
    },
  }
</script>
<style lang="scss">

.casNoRadio .el-cascader-menu:nth-child(1),.casNoRadio .el-cascader-menu:nth-child(2){
  .el-radio{
    display: none;
  }
}

.CInitManage{
  .w100{
    width: 100px;
  }
  .w235{
    width: 235px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 200px;
    }
  }
  .contDio{
    .Ppaging{
      text-align: center;
      padding: 10px 0;
    }
    .productTable{
      .el-radio__label{ display: none;}
    }
    .flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .el-form--label-top .el-form-item__label{
      padding: 0;
      line-height: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/CInitManage/CInitManage.vue